export default "__VITE_ASSET__YTbugNLw__"